<template>
  <section
    class="inline-flex justify-center middle rounded-full"
    :class="{ 'px-2.5': !sessionStore.hasLivePhase, 'mx-auto': sessionStore.userIsObserver }"
  >
    <template v-for="(phase, id) in phases" :key="id">
      <PhasesItemLive
        :currentPhaseData="phase"
        :endCurrentPhase="endPhase"
        :backToPreviousPhase="backToPreviousPhase"
        @endSessionModal="showEndSessionModal"
        v-if="phase['status'] === PHASE_STATUS.LIVE"
      />
      <PhasesItemWaiting
        :class="{ 'pr-5': id == VICE_SESSION_PHASES.DEBRIEF }"
        :phaseData="phase"
        v-if="phase['status'] === PHASE_STATUS.WAITING"
      />
      <PhasesItemCompleted
        :class="{ 'pr-5': id == VICE_SESSION_PHASES.DEBRIEF }"
        :phaseData="phase"
        v-if="phase['status'] === PHASE_STATUS.COMPLETED"
      />
    </template>
  </section>
</template>

<script>
import { PHASE_STATUS, VICE_SESSION_PHASES } from '@/Utils/vice-constants';

import useSessionStore from '@/Stores/useSessionStore';
import PhasesItemLive from './PhasesItemLive.vue';
import PhasesItemWaiting from './PhasesItemWaiting.vue';
import PhasesItemCompleted from './PhasesItemCompleted.vue';

export default {
  props: {
    endPhase: {
      type: Function,
    },

    backToPreviousPhase: {
      type: Function,
    },
  },
  components: { PhasesItemLive, PhasesItemWaiting, PhasesItemCompleted },
  setup(_, { emit }) {
    const showEndSessionModal = () => {
      emit('endSessionModal');
    };
    const sessionStore = useSessionStore();
    const phases = sessionStore.phases;
    return {
      showEndSessionModal,
      phases,
      VICE_SESSION_PHASES,
      PHASE_STATUS,
      sessionStore,
    };
  },
};
</script>
